import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-teal px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg7a5ljxg31">
        <h2 className="text-center text-[1.15rem] font-extrabold uppercase text-white sm:text-[1.7rem]" data-id="element-20" data-mp="avcxsm8avm9h">
          🎁 5 professional bonuses included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-21" data-mp="fsbrx4ryrt7o">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-4 border-navy bg-white px-2.5 py-2 shadow-sm" data-id="element-22" data-mp="1tlufo18fris">
              <h3 className="text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-[0.88rem]" data-id="element-23" data-mp="5xbhg929e11p">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.7rem] font-semibold text-clinical sm:text-[0.82rem]" data-id="element-24" data-mp="3t0ybm32484yp">{bonus.subtitle}</p>
              <p className="mt-1 text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-25" data-mp="1m8ffxlq1sjvr">{bonus.body}</p>
              <p className="mt-1 font-heading text-[0.66rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.78rem]" data-id="element-26" data-mp="1r6z31pgdo1pp">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}